import { useRecoilValue } from 'recoil'
import { currentUser } from 'src/atoms/user'

const domains = ['@southeastern.company']

export const usePreventUserAccess = (): {
  preventAccess: boolean
  blockedPaths: string[]
} => {
  const blockedPaths = ['true-trade-area', 'location-visits', 'area-visits', 'rank', 'tenant-overview']
  const user = useRecoilValue(currentUser)
  if (!user) {
    return {
      preventAccess: false,
      blockedPaths: [],
    }
  }
  if (user.email && domains.some((domain) => user.email.includes(domain))) {
    return {
      preventAccess: true,
      blockedPaths,
    }
  }
  return {
    preventAccess: false,
    blockedPaths: [],
  }
}
